import { jsxs, jsx } from 'react/jsx-runtime';
import { composeEventHandlers } from '@radix-ui/primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DropdownMenuCheckboxItem } from '../../patched-dropdown/Dropdown.mjs';
import { dropdownItem, dropdownItemClickable, dropdownItemContent } from '../../shared/styles/item.vanilla.mjs';
import { DropdownSlot } from '../slot/Slot.mjs';

const DropdownCheckboxItem = forwardRef(
  ({
    children,
    className: classNameFromProps,
    leftSlot,
    onPointerUp,
    ...props
  }, forwardedRef) => {
    const className = classNames(
      dropdownItem,
      !props.disabled && dropdownItemClickable,
      classNameFromProps
    );
    const handlePointerUp = composeEventHandlers(onPointerUp, (event) => {
      if (!event.isDefaultPrevented()) {
        event.preventDefault();
      }
    });
    return /* @__PURE__ */ jsxs(
      DropdownMenuCheckboxItem,
      {
        "data-scope": "dropdown",
        "data-part": "checkbox-item",
        className,
        onPointerUp: handlePointerUp,
        ref: forwardedRef,
        ...props,
        children: [
          /* @__PURE__ */ jsx(DropdownSlot, { "data-scope": "dropdown", "data-part": "checkbox-item-left-slot", children: leftSlot }),
          /* @__PURE__ */ jsx(
            "div",
            {
              "data-scope": "dropdown",
              "data-part": "checkbox-item-content",
              className: dropdownItemContent,
              children
            }
          )
        ]
      }
    );
  }
);

export { DropdownCheckboxItem };
//# sourceMappingURL=CheckboxItem.mjs.map
